/**
 * Analytics utilities
 * Centraliza el tracking de eventos de la aplicación.
 * Actualmente registra en consola (desarrollo) y puede extenderse
 * con cualquier proveedor (Google Analytics, Mixpanel, etc.).
 */

const isDev = process.env.NODE_ENV === "development";

/**
 * Registra el acceso a un módulo.
 * @param {string} moduleId - Identificador del módulo accedido.
 * @param {string} url - URL a la que navega el usuario.
 */
export const trackModuleAccess = (moduleId, url) => {
  if (isDev) {
    console.info("[Analytics] Module access:", moduleId, url);
  }
};

/**
 * Registra la duración de la sesión del usuario al cerrar sesión.
 * @param {number} durationInSeconds - Duración de la sesión en segundos.
 */
export const trackSessionDuration = (durationInSeconds) => {
  if (isDev) {
    console.info("[Analytics] Session duration (s):", durationInSeconds);
  }
};

/**
 * Registra un clic en un botón o elemento interactivo.
 * @param {string} buttonName - Nombre o identificador del botón.
 * @param {string} location - Contexto / sección donde se realizó el clic.
 */
export const trackButtonClick = (buttonName, location) => {
  if (isDev) {
    console.info("[Analytics] Button click:", buttonName, "at", location);
  }
};

/**
 * Registra un inicio de sesión exitoso.
 * @param {string} method - Método de autenticación utilizado (ej: 'cognito').
 */
export const trackLogin = (method) => {
  if (isDev) {
    console.info("[Analytics] Login:", method);
  }
};

/**
 * Registra una excepción o error en la aplicación.
 * @param {string} description - Descripción del error.
 * @param {boolean} fatal - Indica si el error es fatal.
 */
export const trackException = (description, fatal = false) => {
  if (isDev) {
    console.warn("[Analytics] Exception:", description, "fatal:", fatal);
  }
};

/**
 * Registra un paso en el flujo de recuperación de contraseña.
 * @param {string} step - Paso del flujo de recuperación.
 */
export const trackPasswordReset = (step) => {
  if (isDev) {
    console.info("[Analytics] Password reset step:", step);
  }
};

/**
 * Registra la aceptación o rechazo de los términos y condiciones.
 * @param {boolean} accepted - Indica si el usuario aceptó los términos.
 */
export const trackTermsAcceptance = (accepted) => {
  if (isDev) {
    console.info("[Analytics] Terms acceptance:", accepted);
  }
};

/**
 * Registra el envío de un formulario.
 * @param {string} formName - Nombre del formulario.
 * @param {string} formId - Identificador del formulario.
 */
export const trackFormSubmit = (formName, formId) => {
  if (isDev) {
    console.info("[Analytics] Form submit:", formName, formId);
  }
};

/**
 * Registra una solicitud de registro de usuario.
 * @param {object} data - Datos relevantes del registro.
 */
export const trackUserRegistrationRequest = (data) => {
  if (isDev) {
    console.info("[Analytics] User registration request:", data);
  }
};
